import { TablePagination } from '@octano/global-ui';
import { useStudentsRemovalRequestsResolvedList } from './StudentsRemovalRequestsResolvedListLoader';

export interface PerformanceAnalysisTablePaginationProps {
  total: number;
  totalPages: number;
}

export function StudentsRemovalRequestsResolvedTablePagination({
  total,
  totalPages,
}: PerformanceAnalysisTablePaginationProps) {
  const { query, updateQuery } = useStudentsRemovalRequestsResolvedList();

  return (
    <TablePagination
      pagination={{
        currentPage: query.page,
        itemsPerPage: 10,
        onChangePage: (page) => {
          updateQuery({ ...query, page });
        },
        totalItems: total,
        totalPages: totalPages,
      }}
    />
  );
}
